'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  config = require('../../config'),
  utilities = require('../../utilities'),
  featureFlags = require('../../../utilities/featureFlags'),

  DatasheetMainViewerView = Backbone.View.extend({

    initialize: function() {
      this.$viewerHtml = this.$('.DatasheetCarousel-html');
      this.$viewerImg = this.$('.DatasheetCarousel-img');
    },

    goToSlide: function(index, htmlUrl, imageUrl) {
      this.imageUrl = imageUrl;
      $.ajax(htmlUrl, {
        dataType: 'html',
        handleErrorLocally: true,
        data: utilities.addCustIpToDataObject({})
      }).then(_.bind(this.injectHtml, this));

      if (!featureFlags.DisableDatasheetOnMobile.isEnabled())
      {
        // Set image URL and trigger a change event
        this.$viewerImg.attr('src', imageUrl);
      }
      this.trigger('change', null, index);
    },

    injectHtml: function(html) {
      // Fix urls to use correct cdn host
      html = html.replace(/(url\("|data=")(\/)/g, '$1' + config.urls.datasheet.cdnHost + '$2');

      // Fix image src if only image is displayed
      html = html.replace(/src=".*?"/g, 'src="' + this.imageUrl + '"');

      // Inject it in view
      this.$viewerHtml.html(html);
    }

  });

module.exports = DatasheetMainViewerView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/DatasheetMainViewerView.js